import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { HomepageBlock4 } from "@circle-react-shared/BuilderUI/DefaultBlocks/Homepage/HomepageBlock4/HomepageBlock4";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export interface HomepageBlock7Props
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const HomepageBlock7 = forwardRef<HTMLDivElement, HomepageBlock7Props>(
  ({ ...rest }, ref) => <HomepageBlock4 ref={ref} {...rest} />,
);

HomepageBlock7.displayName = "HomepageBlock7";
